(ns app.front.view.admin.users
  (:require [app.domain.group.model :as group-model]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.components :as components]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-users
  (fn [{:keys [db]} [_ filters]]
    {:comm/command {:command    :admin/users
                    :data       filters
                    :on-success [::fetch-users.success]}
     :db           (-> db
                       (update ::state dissoc :user-list)
                       (update ::state assoc :loading? true)
                       (update ::state assoc :stale? false))}))

(rf/reg-event-db ::fetch-users.success
  (fn [db [_ _ user-list]]
    (-> db
        (update ::state assoc :loading? false)
        (update ::state assoc :user-list user-list))))

(rf/reg-sub ::user-list
  :<- [::state]
  :-> :user-list)

(defn set-filter [db attr v]
  (if (or (nil? v) (empty? v))
    (update db ::filter dissoc attr)
    (assoc-in db [::filter attr] v)))

(rf/reg-event-db ::set-filter
  (fn [db [_ attr v]]
    (-> db
        (update ::state set-filter attr v)
        (update ::state assoc :stale? true))))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::stale?
  :<- [::state]
  (fn [state _]
    (:stale? state true)))

(rf/reg-sub ::loading?
  :<- [::state]
  :-> :loading?)

(rf/reg-sub ::filter
  :<- [::state]
  (fn [db _] (::filter db {})))

(rf/reg-sub ::filter-val
  :<- [::filter]
  (fn [filter [_ attr]] (get filter attr)))

(rf/reg-sub ::filter-val-text
  (fn [[_ attr]]
    (rf/subscribe [::filter-val attr]))
  (fn [kws _]
    (->> kws (map name) (str/join ", "))))

(rf/reg-sub ::filter-as-query
  :<- [::filter]
  (fn [filter]
    (let [kw->str #(-> % str (subs 1))]
      (->> filter
           (mapcat (fn [[k v]]
                     (if (coll? v)
                       (map #(vector k (kw->str %)) v)
                       [[k v]])))))))

(defn- fetch-button []
  (let [filter (<sub [::filter])]
    (cc/button
      {:on-click #(>evt [::fetch-users filter])
       :disabled (not (<sub [::stale?]))}
      "Fetch")))

(defn- fetch-report-button []
  (file-download/download-button
    :admin/users-report
    (<sub [::filter-as-query])
    "Download report (csv)"
    {}))

(defn filter-selector [{:keys [values label-text attr]}]
  [ui-ms/multi-select
   (util/mmap {:displayed-text (<sub [::filter-val-text attr])
               :id             (str "filter-select" (name attr))
               :on-change      #(>evt [::set-filter attr %])
               :value          (<sub [::filter-val attr])}
              values label-text)])

(defn filter-text
  [{:keys [attr label-text placeholder]}]
  [ui/text-input
   (util/mmap {:id        (str "filter-text-" (name attr))
               :on-change #(rf/dispatch-sync [::set-filter attr (futil/tval %)])
               :value     (<sub [::filter-val attr])}
              label-text placeholder)])

(def nested-filters :div.flex.flex-col.gap-y-2.ml-4)

(defn- filters []
  [:div.flex.flex-col.gap-y-2
   [ui/help "Empty means no filtering, different filters are AND, inside a filter is OR"]
   [:h4 "Group filters"]
   [filter-selector {:values     [:CA-AB
                                  :CA-BC
                                  :CA-MB
                                  :CA-NB
                                  :CA-NL
                                  :CA-NS
                                  :CA-ON
                                  :CA-PE
                                  :CA-QC
                                  :CA-SK
                                  :CA-NT
                                  :CA-NU
                                  :CA-YT] ;; TODO hard-coded canada list
                     :label-text "Only consider groups with scopes in subdivision"
                     :attr       :group-in-subdivisions}]
   [nested-filters
    [filter-selector {:values     group-model/group-roles
                      :label-text "Member of a group with at least one of the selected roles"
                      :attr       :group-roles}]
    [filter-selector {:values     [:role/group-admin :role/group-reporter] ;; TODO hardcoded
                      :label-text "Member of group with at least one of the selected authorizations"
                      :attr       :group-auth-roles}]]
   [:h4 "User filters"]
   [filter-text {:label-text  "Email address contains text"
                 :placeholder "some.domain.com"
                 :attr        :user-email-fragment}]

   [:div.flex.flex.row.gap-x-4.mt-4
    [fetch-button]
    [fetch-report-button]]])

(defn view [match]
  (let [tr (<sub [:tr])]
    [acommon/admin-page (util/mmap {:title (tr [:admin-tools/user-accounts])} match)
     [acommon/section {:title "Filters"}
      [filters]]
     [acommon/section
      {:title "User accounts"}
      (if (<sub [::loading?])
        (cc/loading-spinner {:with-overlay false})
        [components/structured-list-keyed
         {:wrapper-opts {:aria-label "Entity data"}}
         [":db/id" "Last name" "First name" "Email" "Groups"]
         (for [{:user/keys [first-name last-name email groups] :as u} (<sub [::user-list])]
           {:key   email
            :cells [[:a
                     {:href (href/href :view/admin.entity-lookup-with-param {:search-term (:db/id u)})}
                     (:db/id u)]
                    [:div last-name]
                    [:div first-name]
                    [:div email]
                    [:div (if (seq groups)
                            (->> (map :group/name groups)
                                 (str/join ", "))
                            "-")]]})])]]))

(def route
  {:name :view/admin.users
   :view view})
